/** Извлекает только цифры из строки. */
export function digitsOnly(value) {
  return String(value ?? '').replace(/\D/g, '')
}

/** 10 национальных цифр из E.164, маски или вставки 8/7… */
export function parseRuPhoneDigits(value) {
  let d = digitsOnly(value)
  if (!d) return ''
  if (d.length >= 11 && (d[0] === '7' || d[0] === '8')) {
    return d.slice(1, 11)
  }
  return d.slice(0, 10)
}

/** Маска национальной части в поле ввода: (999) 123-45-67 */
export function formatNationalMasked(nationalDigits) {
  const d = parseRuPhoneDigits(nationalDigits)
  if (!d) return ''
  if (d.length <= 3) return `(${d}`
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`
  if (d.length <= 8) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 8)}-${d.slice(8, 10)}`
}

/** Полный номер для отображения: +7 (999) 123-45-67 */
export function formatRuPhoneDisplay(value) {
  const d = parseRuPhoneDigits(value)
  if (!d) return ''
  return `+7 ${formatNationalMasked(d)}`
}

/** E.164: +7XXXXXXXXXX или '' */
export function normalizeRuPhoneE164(value) {
  const d = parseRuPhoneDigits(value)
  if (d.length < 10) return ''
  return `+7${d}`
}

export function isRuPhoneComplete(value) {
  return parseRuPhoneDigits(value).length === 10
}

/** Индекс цифры в строке маски → позиция каретки после неё */
export function caretAfterDigitIndex(masked, digitIndex) {
  if (digitIndex <= 0) {
    const open = masked.indexOf('(')
    return open >= 0 ? open + 1 : 0
  }
  let seen = 0
  for (let i = 0; i < masked.length; i += 1) {
    if (/\d/.test(masked[i])) {
      seen += 1
      if (seen >= digitIndex) return i + 1
    }
  }
  return masked.length
}

export function countDigitsBefore(str, index) {
  let n = 0
  for (let i = 0; i < index && i < str.length; i += 1) {
    if (/\d/.test(str[i])) n += 1
  }
  return n
}
